import gpsAntenna from "../assets/images/Antenna/1.jpg";
import gpsAntenna2 from "../assets/images/Antenna/2.png";
import gpsAntenna3 from "../assets/images/Antenna/3.jpg";
import gpsAntenna4 from "../assets/images/Antenna/4.jpg";
import gpsAntenna5 from "../assets/images/Antenna/5.jpg";
import gpsAntenna6 from "../assets/images/Antenna/6.jpg";
import gpsAntenna7 from "../assets/images/Antenna/7.avif";
import gpsAntenna8 from "../assets/images/Antenna/8.png";
import gpsAntenna9 from "../assets/images/Antenna/9.jpg";
import gpsAntenna10 from "../assets/images/Antenna/10.jpg";
import cavityfilter from "../assets/images/Cavity_Filter/1.png";
import cavityfilter2 from "../assets/images/Cavity_Filter/2.jpg";
import cavityfilter3 from "../assets/images/Cavity_Filter/3.jpg";
import cavityfilter4 from "../assets/images/Cavity_Filter/4.jpg";
import cavityfilter5 from "../assets/images/Cavity_Filter/5.jpg";
import cavityfilter6 from "../assets/images/Cavity_Filter/6.jpg";
import cavityfilter7 from "../assets/images/Cavity_Filter/7.jpg";
import cavityfilter8 from "../assets/images/Cavity_Filter/8.jpg";
import ceramicFilter from "../assets/images/Ceramic_and_SAW/1.png";
import ceramicFilter2 from "../assets/images/Ceramic_and_SAW/2.jpg";
import ceramicFilter3 from "../assets/images/Ceramic_and_SAW/3.jpg";
import ceramicFilter4 from "../assets/images/Ceramic_and_SAW/4.jpg";
import ceramicFilter5 from "../assets/images/Ceramic_and_SAW/5.jpg";
import ceramicFilter6 from "../assets/images/Ceramic_and_SAW/6.jpg";
import ceramicFilter7 from "../assets/images/Ceramic_and_SAW/7.jpg";
import ceramicFilter8 from "../assets/images/Ceramic_and_SAW/8.jpg";
import ceramicFilter9 from "../assets/images/Ceramic_and_SAW/9.jpg";
import lna from "../assets/images/LNA/Low-Noise-Amplifier.webp";
import bismuth from "../assets/images/Non_Ferrous_Metals/Bismuth/1.jpg";
import bismuth2 from "../assets/images/Non_Ferrous_Metals/Bismuth/2.jpg";
import bismuth3 from "../assets/images/Non_Ferrous_Metals/Bismuth/3.jpg";
import lumps from "../assets/images/Non_Ferrous_Metals/Lumps/1.jpg";
import lumps2 from "../assets/images/Non_Ferrous_Metals/Lumps/2.jpg";
import lumps3 from "../assets/images/Non_Ferrous_Metals/Lumps/3.jpg";
import brass from "../assets/images/Non_Ferrous_Metals/Magnsium_Ingots/1.jpg";
import brass1 from "../assets/images/Non_Ferrous_Metals/Magnsium_Ingots/2.jpg";

import silicon from "../assets/images/Non_Ferrous_Metals/Silicon_Lumps/1.jpg";
import silicon2 from "../assets/images/Non_Ferrous_Metals/Silicon_Lumps/2.jpg";
import silicon3 from "../assets/images/Non_Ferrous_Metals/Silicon_Lumps/3.jpg"; 
import silicon4 from "../assets/images/Non_Ferrous_Metals/Silicon_Lumps/4.jpg";
import silicon5 from "../assets/images/Non_Ferrous_Metals/Silicon_Lumps/5.jpg";
import zinc from "../assets/images/Non_Ferrous_Metals/Zinc_Ingots/1.jpg";
import zinc2 from "../assets/images/Non_Ferrous_Metals/Zinc_Ingots/2.jpg";
import zinc3 from "../assets/images/Non_Ferrous_Metals/Zinc_Ingots/3.jpg";
import rfadapter from "../assets/images/RF_Adapter/1.jpg";
import rfadapter2 from "../assets/images/RF_Adapter/2.jpg";
import rfadapter3 from "../assets/images/RF_Adapter/3.jpg";
import rfadapter4 from "../assets/images/RF_Adapter/4.png";
import rfadapter5 from "../assets/images/RF_Adapter/5.jpg";

import rfcableassembly1 from "../assets/images/RF_Cable_Assembly/1.jpg";
import rfcableassembly2 from "../assets/images/RF_Cable_Assembly/2.jpg";
import rfcableassembly3 from "../assets/images/RF_Cable_Assembly/3.jpg";

import rfcables from "../assets/images/RF_Cables/1.jpg";
import rfcables2 from "../assets/images/RF_Cables/2.jpg";
import rfcables3 from "../assets/images/RF_Cables/3.jpeg";
import rfcables4 from "../assets/images/RF_Cables/4.jpg";

import rfconnectors1 from "../assets/images/RF_Connectors/1.jpg";
import rfconnectors2 from "../assets/images/RF_Connectors/2.jpg";
import rfconnectors3 from "../assets/images/RF_Connectors/3.jpg";
import rfconnectors4 from "../assets/images/RF_Connectors/4.png";

import waveguides1 from "../assets/images/Waveguides/1.jpg";
import waveguides2 from "../assets/images/Waveguides/2.jpg";
import waveguides3 from "../assets/images/Waveguides/3.jpg";
import waveguides4 from "../assets/images/Waveguides/4.jpg";
import waveguides5 from "../assets/images/Waveguides/5.jpg";
import waveguides6 from "../assets/images/Waveguides/6.jpg";
import waveguides7 from "../assets/images/Waveguides/7.png";
import waveguides8 from "../assets/images/Waveguides/8.jpg";
import waveguides9 from "../assets/images/Waveguides/9.png";



export const categoriesDB = {
  Antennas: [
    { id: 1, name: "", img: gpsAntenna, desc: "" },
    { id: 2, name: "", img: gpsAntenna2, desc: "" },
    { id: 3, name: "", img: gpsAntenna3, desc: "" },
    { id: 4, name: "", img: gpsAntenna4, desc: "" },
    { id: 5, name: "", img: gpsAntenna5, desc: "" },
    { id: 6, name: "", img: gpsAntenna6, desc: "" },
    { id: 7, name: "", img: gpsAntenna7, desc: "" },
    { id: 8, name: "", img: gpsAntenna8, desc: "" },
    { id: 9, name: "", img: gpsAntenna9, desc: "" },
    { id: 10, name: "", img: gpsAntenna10, desc: "" },
  ],
  "Cavity Filters": [
    { id: 1, name: "", img: cavityfilter, desc: "" },
    { id: 2, name: "", img: cavityfilter2, desc: "" },
    { id: 3, name: "", img: cavityfilter3, desc: "" },
    { id: 4, name: "", img: cavityfilter4, desc: "" },
    { id: 5, name: "", img: cavityfilter5, desc: "" },
    { id: 6, name: "", img: cavityfilter6, desc: "" },
    { id: 7, name: "", img: cavityfilter7, desc: "" },
    { id: 8, name: "", img: cavityfilter8, desc: "" },
  ],
  "Ceramic and SAW": [
    { id: 1, name: "", img: ceramicFilter, desc: "" },
    { id: 2, name: "", img: ceramicFilter2, desc: "" },
    { id: 3, name: "", img: ceramicFilter3, desc: "" },
    { id: 4, name: "", img: ceramicFilter4, desc: "" },
    { id: 5, name: "", img: ceramicFilter5, desc: "" },
    { id: 6, name: "", img: ceramicFilter6, desc: "" },
    { id: 7, name: "", img: ceramicFilter7, desc: "" },
    { id: 8, name: "", img: ceramicFilter8, desc: "" },
    { id: 9, name: "", img: ceramicFilter9, desc: "" },
  ],
  "LNA": [
    { id: 1, name: "Low Noise Amplifier", img: lna, desc: "" },
  ],
   "Non-Ferrous Metals": {
    Bismuth: [
      { id: 1, name: "", img: bismuth, desc: "" },
        { id: 2, name: "", img: bismuth2, desc: "" },
        { id: 3, name: "", img: bismuth3, desc: "" },
    ],
    Lumps: [
      { id: 1, name: "", img: lumps, desc: "" },
        { id: 2, name: "", img: lumps2, desc: "" },
        { id: 3, name: "", img: lumps3, desc: "" },

    ],
    "Magnsium Ingots": [
      { id: 1, name: "", img: brass, desc: "" },
        { id: 2, name: "", img: brass1, desc: "" },

    ],
    "Silicon Lumps": [
      { id: 1, name: "", img: silicon, desc: "" },
      { id: 2, name: "", img: silicon2, desc: "" },
      { id: 3, name: "", img: silicon3, desc: "" },
      { id: 4, name: "", img: silicon4, desc: "" },
      { id: 5, name: "", img: silicon5, desc: "" },
    ],
    "Zinc Ingots": [
      { id: 1, name: "", img: zinc, desc: "" },
      { id: 2, name: "", img: zinc2, desc: "" },
      { id: 3, name: "", img: zinc3, desc: "" },
    ],
  },
    "RF Adapters": [
    { id: 1, name: "N male to N female", img: rfadapter , desc: "" },
    { id: 2, name: "N to N", img: rfadapter2, desc: "" },
    { id: 3, name: "N to SMA", img: rfadapter3, desc: "" },
    { id: 4, name: "rf-adapters", img: rfadapter4, desc: "" },
    { id: 5, name: "SMA to SMA", img: rfadapter5, desc: "" },
    ],
    "RF Cable Assembly": [
    { id: 1, name: "", img: rfcableassembly1 , desc: "" },
    { id: 2, name: "", img: rfcableassembly2, desc: "" },
    { id: 3, name: "", img: rfcableassembly3, desc: "" },
    ],
    "RF Cables": [
    { id: 1, name: "", img: rfcables , desc: "" },
    { id: 2, name: "", img: rfcables2, desc: "" },
    { id: 3, name: "", img: rfcables3, desc: "" },
    { id: 4, name: "", img: rfcables4, desc: "" },
    ],
    "RF Connectors": [
    { id: 1, name: "", img: rfconnectors1 , desc: "" },
    { id: 2, name: "", img: rfconnectors2, desc: "" },
    { id: 3, name: "", img: rfconnectors3, desc: "" },
    { id: 4, name: "", img: rfconnectors4, desc: "" },
    ],
    "Waveguides": [
    { id: 1, name: "", img: waveguides1 , desc: "" },
    { id: 2, name: "", img: waveguides2, desc: "" },
    { id: 3, name: "", img: waveguides3, desc: "" },
    { id: 4, name: "", img: waveguides4, desc: "" },
    { id: 5, name: "", img: waveguides5, desc: "" },
    { id: 6, name: "", img: waveguides6, desc: "" },
    { id: 7, name: "", img: waveguides7, desc: "" },
    { id: 8, name: "", img: waveguides8, desc: "" },
    { id: 9, name: "", img: waveguides9, desc: "" },
  ],

  default: [
    { id: 1, name: "Generic Product", img: "📦", desc: "Product details coming soon." },
  ],
};
